import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import ReactMarkdown from 'react-markdown'
import './FrontPage.css';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import FullbleedContentBlock from '../components/ContentBlocks/FullbleedContentBlock';
import { fetchFront, fetchMenu } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import Helmet from 'react-helmet';
import slug from 'slug';
import RenderProduct from '../components/RenderProduct';
import RenderCategory from '../components/RenderCategory';

import ContentBlockImage from '../components/ContentBlocks/ContentBlockImage'
import ContentBlockHolder from '../components/ContentBlocks/ContentBlockHolder'
import ContentBlock from '../components/ContentBlocks/ContentBlock'
import './MenuPage.css';

class FrontPage extends Component {

  componentDidMount() {
    if (!this.props.containers||!this.props.liftField) {
      this.props.fetchFront(this.props.intl.locale, this.props.date);
    }
  }

  render() {
	  
	const isItemValid = (item, time) => {
      return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
        && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
    }

    const {menus, categories, products} = {...this.props};

    const productGroups = categories.filter(category => isItemValid(category, this.props.date));  
  
    return (
      <div className="front">
        <div>
          <Helmet title="Boulevard" titleTemplate="%s" />
          {!this.props.headField && <Loader/>}
          {this.props.headField && <FullbleedHero fields={this.props.headField}/>}
          {this.props.containers &&
            this.props.containers.map((key, i) => {
              if(key.sys.contentType.sys.id==='container') {
                if(key.fields.type===true) {
                  const align = key.fields.align.toLowerCase()

                  if((align==='left'||align==='right') && key.fields.image) {
                    return (
                      <ContentBlockImage align={align} fields={key.fields} key={key.sys.id} />
                    )
                  }

                  if(align==='dual') {
                    return (
                      <ContentBlockHolder dual key={key.sys.id}>
                        {key.fields.elements.map((key, i) => {
                          return (
                            <ContentBlock key={key.sys.id} align={key.fields.align.toLowerCase()} fields={key.fields} />
                          )
                        })}
                      </ContentBlockHolder>
                    )
                  }
                  return (
                    <div key={key.sys.id}>
                    	{ key.fields.image && <div className="feelImage" style={{backgroundImage: 'url('+key.fields.image[0].fields.file.url+'?fm=jpg&q=80)'}}></div>}
	                    <ContentBlockHolder indexNum={i}>
	                      <ContentBlock align={align} fields={key.fields} />
	                    </ContentBlockHolder>
	                </div>
                  )
                }
                if(key.fields.type===false) {
                  return (
                    <FullbleedContentBlock key={key.sys.id} align={key.fields.align.toLowerCase()} fields={key.fields} className={slug(key.fields.heading.toLowerCase())} />
                  )
                }
              }
              
              return null;
            })
          }
          
          { menus.map((menu) => {	
        	  if(menu.fields.title === 'Lounas' || menu.fields.title === 'Lunch') { 
        		   return (
        				   <div className="menu">
        				   <div className="category">
        				   <div className="container">
        				   <div className="products-wrapper">
        				   <div className="products-categories">
        				   <div className="frontapage-menu" key={menu.sys.id}>
	                      	{(menu.fields.longTitle || menu.fields.description) &&
	                          <div className="category-intro">
	                            {menu.fields.longTitle && <h3>{menu.fields.longTitle}</h3>}
	                            {menu.fields.description && <ReactMarkdown source={menu.fields.description} />}
	                          </div>
	                        }
	                        {menu.fields.children && menu.fields.children.map((child, index) => {
	                          let product = products.find((p) => {
	                            return p.sys.id === child.sys.id
	                          })
	                          let category = productGroups.find((p) => {
	                            return p.sys.id === child.sys.id
	                          })

	                          if(product) {
	                            return(
	                              <RenderProduct product={product} key={product.fields.title} {...this.props} />
	                            )
	                          }

	                          if(category) {
	                            return(
	                              <RenderCategory category={category} key={category.fields.title} {...this.props} />
	                            )
	                          }

	                          return null;
	                        })}
	                        </div>
	                        </div>
	                        </div>
	                        </div>
	                        </div>
	                        </div>
        		   );
        	  }        	  
        	  return null;
          	})
          }
        </div>
      </div>
    );
  }
}

FrontPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  headField:state.front.header,
  date:state.date,
  containers: state.front.containers,
  menus:state.menus,
  products:state.products,
  categories:state.categories
});

const mapDispatchToProps = {
  fetchFront,
  fetchMenu
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(FrontPage));



// WEBPACK FOOTER //
// ./src/containers/FrontPage.js